import SEO_ROUTES from "@/data/seoRoutes.json";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo, breadcrumbSchema, faqSchema } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { FaqAccordion } from "@/components/site/FaqAccordion";
import { Disclaimer } from "@/components/site/Disclaimer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { GENERAL_FAQS } from "@/data/faqs";
import { PRODUCTS } from "@/data/products";

const crumbs = [
  { name: "Home", path: "/" },
  { name: "FAQs", path: "/faqs" },
];

export default function Faqs() {
  return (
    <>
      <Seo
        title={SEO_ROUTES["/faqs"].title}
        description={SEO_ROUTES["/faqs"].description}
        path="/faqs"
        jsonLd={[breadcrumbSchema(crumbs), faqSchema(GENERAL_FAQS)]}
      />
      <PageHero crumbs={crumbs} eyebrow="Help centre" title="Frequently Asked Questions" intro="Clear answers about our products, ordering, delivery and pricing. If pricing, delivery or returns details are not covered here, please contact us for confirmation." />
      <section className="section" aria-labelledby="general-heading">
        <div className="container-site grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <h2 id="general-heading" className="h-section mb-6">
              General questions
            </h2>
            <FaqAccordion faqs={GENERAL_FAQS} idPrefix="faqs-page" />
          </div>
          <aside className="space-y-6 lg:col-span-4">
            <div className="card-soft p-6">
              <h2 className="text-xl font-semibold">Product questions</h2>
              <p className="mt-2 text-sm text-muted-foreground">Each product page has its own FAQs.</p>
              <ul className="mt-4 space-y-2">
                {PRODUCTS.map((p) => (
                  <li key={p.slug}>
                    <Link to={`${p.path}`} className="link-accent inline-flex items-center gap-1.5 text-sm" data-testid={`faqs-product-link-${p.slug}`}>
                      {p.name} FAQs <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="card-soft p-6">
              <h2 className="text-xl font-semibold">Still have a question?</h2>
              <p className="mt-2 text-sm text-muted-foreground">We’re happy to help during business hours.</p>
              <div className="mt-4 flex flex-col gap-2">
                <WhatsAppButton testid="faqs-whatsapp" location="faqs" />
                <Link to="/contact" className="btn btn-outline">
                  Contact us
                </Link>
              </div>
            </div>
          </aside>
        </div>
        <div className="container-site mt-12">
          <Disclaimer />
        </div>
      </section>
    </>
  );
}
